import '../input/text-input';
import '../input/button-input';

import{ html } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';

import { FormElement } from './form';
import { TextInput } from '../input/text-input';

@customElement('search-form')
export class SearchForm extends FormElement {

    // Props

    @query('text-input')
    _input: TextInput;

    @state()
    _searchValue: string = '';

    // Lifecycle Hooks

    firstUpdated() {

        // add classes
        this.classList.add('Form', 'Form--search');
    }

    // Render

    render() {
        return html`
            <form action="/search">
                <div class="Form-body">
                    <text-input 
                        name="query" 
                        placeholder="Search"
                        .required="${ true }"
                        @input="${ () => this._searchValue = this._input.value }"
                    /></text-input>
                </div>
                <div class="Form-footer">
                    ${ this.submitButtonTemplate('search', '→', this._searchValue == '') }
                </div>
            </form>
        `;
    }

    createRenderRoot() { 
        return this;
    }

}